import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './SplashScreen.css';
import logo from '../assets/logo.png';
import splashBg from '../assets/splash/web_splash_background_clean.png';
import iconInvestors from '../assets/splash/web_icon_investors.png';
import iconBoardMember from '../assets/splash/web_icon_board_member.png';
import iconSecretary from '../assets/splash/web_icon_secretary.png';
import iconCeo from '../assets/splash/web_icon_ceo.png';
import iconSuperAdmin from '../assets/splash/web_icon_super_admin.png';

const ROLE_ICONS = [
  { img: iconCeo,         label: 'الرئيس التنفيذي' },
  { img: iconSecretary,   label: 'أمين السر' },
  { img: iconBoardMember, label: 'عضو مجلس' },
  { img: iconInvestors,   label: 'المساهمون' },
  { img: iconSuperAdmin,  label: 'سوبر أدمن' },
];

function SplashScreen({ onFinish }) {
  const [fadeOut, setFadeOut] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadeOut(true), 3800);
    const doneTimer = setTimeout(() => {
      if (onFinish) onFinish();
      else navigate('/login');
    }, 4500);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(doneTimer);
    };
  }, [onFinish, navigate]);

  return (
    <div
      className={`splash${fadeOut ? ' splash--fade-out' : ''}`}
      style={{ backgroundImage: `url(${splashBg})` }}
    >
      {/* Dark teal→navy overlay for text legibility */}
      <div className="splash__overlay" />

      <div className="splash__content">
        {/* Logo */}
        <div className="splash__logo-wrap">
          <span className="splash__logo-glow" />
          <img src={logo} alt="Corp Pass" className="splash__logo" />
        </div>

        {/* App name */}
        <h1 className="splash__title">Corp Pass</h1>
        <p className="splash__title-ar">كورب باس</p>
        <p className="splash__subtitle">منصة حوكمة الشركات و المنظمات</p>

        {/* Role icons */}
        <div className="splash__roles">
          {ROLE_ICONS.map((role, i) => (
            <div
              className="splash__role"
              key={role.label}
              style={{ animationDelay: `${0.6 + i * 0.15}s` }}
            >
              <span className="splash__role-icon">
                <img src={role.img} alt="" />
              </span>
              <span className="splash__role-label">{role.label}</span>
            </div>
          ))}
        </div>

        {/* Loader */}
        <div className="splash__loader">
          <div className="splash__loader-track">
            <div className="splash__loader-fill" />
          </div>
        </div>
      </div>

      {/* Footer */}
      <p className="splash__footer">© Corp Pass {new Date().getFullYear()}</p>
    </div>
  );
}

export default SplashScreen;
